/// <amd-module name="Wiki/PageTree/Helper" />
import { RepoConstants } from "Wiki/ViewCommon/Constants";

/**
 * Gets a list with all the parent full paths of a provided path in the correct order.
 * @param path The path
 * @returns A list with parent paths, excluding the provided one.
 * @example ("/a/b/c") returns ["/", "/a", "/a/b"]
 * Copied from /Tfs/Service/WebAccess/VersionControl/Scripts/VersionControlPath.ts
 */
export function getParentPaths(path: string): string[] {
    const partials: string[] = [];

    if (path.trim()) {
        let previous = path;
        let parent = getFolderName(previous);
        while (previous !== parent) {
            partials.push(parent);
            previous = parent;
            parent = getFolderName(previous);
        }
    }

    return partials.reverse();
}

/**
 * Gets the containing directory of the last path component.
 * @param path The path
 * @returns Path characters up to the last slash.
 *          The trailing slash is included if the result is the root directory ("/" or "$/").
 *          Otherwise, the trailing slash is not included.
 *          Empty string if the path contains no slash.
 * Copied from /Tfs/Service/WebAccess/VersionControl/Scripts/VersionControlPath.ts
 */
function getFolderName(path: string): string {
    let pos: number;
    let folder: string;

    if (path) {
        pos = path.lastIndexOf(RepoConstants.PathSeparator);
        if (pos >= 0) {
            folder = path.substr(0, pos);
            if (folder === "") {
                return RepoConstants.RootPath;
            }

            return folder;
        }
    }

    return "";
}
